import { Configuration, ContentEditApi, EmbeddingsApi, VoiceoverApi } from '@videoblocks/ml-text-service-client';

export const basePath = process.env.ML_TEXT_SERVICE_HOST ?? 'https://ml-text-service.internal.storyblocks.dev';

export const config = new Configuration({
    basePath,
});

export const contentEditApi = new ContentEditApi(config);
export const embeddingsApi = new EmbeddingsApi(config);
export const voiceoverApi = new VoiceoverApi(config);
